import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs'; // Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent
import { map } from 'rxjs/operators'; //, filter, scan



@Injectable()
export class HttpService {

  constructor(private http: HttpClient) {}

  public pageData;

  getMagazines() {
	  return this.http.get('https://dynamicmagazine.simadesign.de/api/magazines/4');
  }

  getPages() {
    return this.http.get('https://dynamicmagazine.simadesign.de/api/pages/4');
  }

  getPage( pid: string) {
    return this.http.get('https://dynamicmagazine.simadesign.de/api/page/'+pid+'/4'); //,{params: params});
  }

  getArticles( pid: string) {
    return this.http.get('https://dynamicmagazine.simadesign.de/api/articles/'+pid+'/4');
  }

  getPagesWithArticles( pid: string) {
    return this.http.get('https://dynamicmagazine.simadesign.de/api/pagearticles/'+pid+'/4');
  }

  getNextPrevArticle( pid: string) {
    return this.http.get('https://dynamicmagazine.simadesign.de/api/nextprevarticles/'+pid+'/4');
  }

  getCoverContent() {
    return this.http.get('https://dynamicmagazine.simadesign.de/api/covercontent/4');
  }

}
